// extracted by mini-css-extract-plugin
export default {"Page":"ComplexCheckout_Page__NIV8H"};